<script>
export default {
  mounted: () => {
    window.onscroll = function () {
      onwindowScroll();
    };
    var navbar = document.getElementById( "navbar" );

    function onwindowScroll() {
      if (
          document.body.scrollTop > 50 ||
          document.documentElement.scrollTop > 50
      ) {
        navbar.style.backgroundColor = "#530D93";
        navbar.style.padding = "10px";
      } else {
        navbar.style.backgroundColor = "";
        navbar.style.padding = "20px";
      }
    }
  },
  methods: {
    /**
     * Toggle menu
     */
    // toggleMenu() {
    //   document.getElementById("navbarCollapse").classList.toggle("show");
    // },
  },
};
</script>

<template>

  <!--Navbar Start-->
  <nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark" id="navbar">
    <div class="container">
      <!-- LOGO -->
      <!--      <a class="navbar-brand logo text-uppercase" href="/">-->
      <!--        <div class="area">Yurist Adliya Uz</div>-->
      <!--      </a>-->
      <!--      <button-->
      <!--        class="navbar-toggler"-->
      <!--        type="button"-->
      <!--        data-toggle="collapse"-->
      <!--        data-target="#navbarCollapse"-->
      <!--        aria-controls="navbarCollapse"-->
      <!--        aria-expanded="false"-->
      <!--        aria-label="Toggle navigation"-->
      <!--        @click="toggleMenu()"-->
      <!--      >-->
      <!--        <i class="mdi mdi-menu"></i>-->
      <!--      </button>-->
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <!--        <ul class="navbar-nav ml-auto navbar-center" id="mySidenav" v-scroll-spy-active>-->
        <!--          <li class="nav-item">-->
        <!--            <a v-scroll-to="'#home'" href="javascript: void(0);" class="nav-link">Home</a>-->
        <!--          </li>-->
        <!--          <li class="nav-item">-->
        <!--            <a v-scroll-to="'#services'" href="javascript: void(0);" class="nav-link">Services</a>-->
        <!--          </li>-->
        <!--          <li class="nav-item">-->
        <!--            <a v-scroll-to="'#features'" href="javascript: void(0);" class="nav-link">Features</a>-->
        <!--          </li>-->
        <!--          <li class="nav-item">-->
        <!--            <a v-scroll-to="'#pricing'" href="javascript: void(0);" class="nav-link">Pricing</a>-->
        <!--          </li>-->
        <!--          <li class="nav-item">-->
        <!--            <a v-scroll-to="'#team'" href="javascript: void(0);" class="nav-link">Team</a>-->
        <!--          </li>-->
        <!--          <li class="nav-item">-->
        <!--            <a v-scroll-to="'#blog'" href="javascript: void(0);" class="nav-link">Blog</a>-->
        <!--          </li>-->
        <!--          <li class="nav-item">-->
        <!--            <a v-scroll-to="'#contact'" href="javascript: void(0);" class="nav-link">Contact</a>-->
        <!--          </li>-->
        <!--        </ul>-->
        <div class="nav-button ml-auto mt-3" >
          <ul class="nav navbar-nav navbar-right" style="width: 100%">
            <li>
              <a href="https://www.minjust.uz" target="_blank" class="iconStyle  p-1">
                <i class="fas fa-globe fa-2x"></i>
              </a>
            </li>
            <li>
              <a href="info@adliya.uz" target="_blank" class="iconStyle  p-1">
                <i class="far fa-envelope-open  fa-2x"></i>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/groups/adliya/" target="_blank" class="iconStyle  p-1">
                <i class="fab fa-facebook-square  fa-2x"></i>
              </a>
            </li>
            <li>
              <a href="https://t.me/huquqiyaxborot" target="_blank" class="iconStyle  p-1" >
                <i class="fab fa-telegram  fa-2x"></i>
              </a>
            </li>
            <li>
              <a href="https://advice.uz" target="_blank" class="iconStyle  p-1">
                <i class="fas fa-audio-description fa-2x"></i>
              </a>
            </li>
            <li>
              <a href="https://lex.uz/ru/" target="_blank" class="iconStyle  p-1">
                <i class="fas fa-balance-scale fa-2x"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
  <!-- Navbar End -->
</template>

<style>
@import url(https://fonts.googleapis.com/css?family=Open+Sans);

body {
  font-family: "Open Sans", Impact;
}

.area {
  text-align: center;
  font-size: 1.4em;
  color: #fff;
  letter-spacing: 0px;
  font-weight: 700;
  text-transform: uppercase;
  animation: blur 1.8s ease-out infinite;
  text-shadow: 0px 0px 1px #fff, 0px 0px 3px #fff;
}

@keyframes blur {
  from {
    text-shadow: 0px 0px 30px #fff,
    0px 0px 3px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #fff,
    0px 0px 6px #7B96B8,
    0px 0px 20px #7B96B8,
    0px 10px 12px #7B96B8,
    0px 10px 12px #7B96B8,
    0px 10px 12px #7B96B8,
    0px 10px 12px #7B96B8,
    0px -10px 12px #7B96B8,
    0px -10px 12px #7B96B8;
  }
}


</style>
